export default "__VITE_ASSET__CF3yhYv3__"